'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLooks3 = function MdLooks3(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 17.5v-2.5c0-1.9-1.5-3.4-3.3-3.4h-6.7v3.4h6.7v3.4h-3.3v3.2h3.3v3.4h-6.7v3.4h6.7c1.8 0 3.3-1.5 3.3-3.4v-2.5c0-1.4-1.1-2.5-2.5-2.5 1.4 0 2.5-1.1 2.5-2.5z m6.7-12.5c1.8 0 3.3 1.6 3.3 3.4v23.2c0 1.8-1.5 3.4-3.3 3.4h-23.3c-1.8 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.6-3.4 3.4-3.4h23.3z' })
        )
    );
};

exports.default = MdLooks3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/looks-3.js
// module id = 2529
// module chunks = 0